import React from 'react'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Dialog from 'components/dialog'
import NewConversationForm from './new-conversation-form'
import { useIsMobile } from 'lib/hooks'

const NewConversationDialog = ({ trigger }) => {
  const fullScreen = useIsMobile()
  return (
    <Dialog trigger={trigger} fullScreen={fullScreen} fullWidth>
      {({ closeDialog }) => (
        <>
          <DialogTitle>New Conversation</DialogTitle>
          <DialogContent dividers>
            <NewConversationForm
              onSuccess={closeDialog}
              onCancel={closeDialog}
            />
          </DialogContent>
        </>
      )}
    </Dialog>
  )
}

export default NewConversationDialog
